import { createSlice } from "@reduxjs/toolkit";

const companySlice = createSlice({
    name: "auth",
    initialState: {
        companyData: null,
    },
    reducers: {
        setCompanyData: (state, action) => {
            state.companyData = action.payload;
        },
        resetCompanyData: (state, action) => {
            state.companyData = null;
        },
    },
});

export const { setCompanyData, resetCompanyData } = companySlice.actions;
export default companySlice.reducer;
